import OrdersFiltersModule from "./OrdersFiltersModule";

export default OrdersFiltersModule;